"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useResponsiveValue", {
    enumerable: true,
    get: function() {
        return useResponsiveValue;
    }
});
var _react = require("@chakra-ui/react");
var useResponsiveValue = function(value) {
    return value ? typeof value === "string" ? value : (0, _react.useBreakpointValue)(value, "base") : undefined;
};
